import { Link } from '@mui/material';
import { contactHref } from '../helpers';
import { formatContactDetail } from './FormatContactDetail';

interface Props {
  contactType: string;
  contactDetail: string;
}

export const ContactLink = ({ contactType, contactDetail }: Props) => {
  return (
    <Link href={contactHref({ contactType, contactDetail })} variant="body2">
      {formatContactDetail({ contactDetail })}
    </Link>
  );
};
